// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Frequency: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M13 22h-.006a1 1 0 0 1-.994-.885v-.005L10.76 9.9 10 14.18a1.002 1.002 0 0 1-.907.82H9.09l-.052.001c-.438 0-.811-.282-.946-.674l-.002-.007L7 11.16v.16c-.137.399-.51.681-.948.681L5.997 12H6 3a1 1 0 0 1 0-2h2.28l.77-2.32a1.001 1.001 0 0 1 1.898-.007l.002.007.76 2.32L10 2.82c.088-.47.495-.82.984-.82h.017H11h.006a1 1 0 0 1 .994.885v.005l1.13 10.17.87-6.2a1.002 1.002 0 0 1 2-.133v.003l1.11 3.89c.149-.356.489-.605.888-.62H21a1 1 0 0 1 0 2h-2.28L18 14.32c-.137.399-.51.681-.948.681L16.997 15H17a1.001 1.001 0 0 1-.938-.723l-.002-.007-.71-2.49L14 21.14a1 1 0 0 1-.99.86H13h.001H13Z" />
  </SvgIcon>
);

Frequency.activeColor = 'inherit';
Frequency.muiName = 'Frequency';
